export default __webpack_public_path__ + "static/media/makcwelllm.849df409.png";